import https, { getApiConfig } from '../utils/request'
import { RequestParams, ContentType, Method } from 'axios-mapper'

// export const getHelpAllCategory = () => https(getApiConfig().migrateUrl)
//   .request('/ke/v1/content/topics', Method.GET)
//   .then((r: any) => r.data)

// 获取板块下面的分类树
export const getHelpCategory = (topicsId) => https(getApiConfig().migrateUrl)
  .request(`/ke/v1/content/topic/${topicsId}`, Method.GET)
  .then((r: any) => r.data)

// 获取二级分类下的文章列表
export const getArticleByCid = (cid: string, page: number, size: number) => https(getApiConfig().migrateUrl)
  .request(`/ke/v1/content/articles?category_id=${cid}&page=${page}&size=${size}`)
  .then((r: any) => r)

// 根据文章ID获取文章内容
export const getArticleDetailByAid = (aid: any) => https(getApiConfig().migrateUrl)
  .request(`/ke/v1/content/articles/${aid}`)
  .then((r: any) => r.data)

// 获取板块下的语言种类
export const getTopicLanguage = (aid: any) => https(getApiConfig().migrateUrl)
.request(`/ke/v1/content/topic-language/${aid}`)
.then((r: any) => r.data)

